import {MDCSlider} from '@material/slider';


const filters = (Simplebar) => {
    const filters = document.querySelector(".filters");
    const mdcSliders = document.querySelectorAll(".mdc-slider");
    const toggleBtn = document.querySelector(".filters__btn-show");
    const toggleCloseBtn = document.querySelector(".filters__btn-close");
    const toggleInnerBtn = document.querySelector(".filters__btn-more");
    const toggleWrap = document.querySelector(".filters__toggle-wrap");
    const toggleInnerWrap = document.querySelector(".filters__toggle-wrap-inner");
    const filterSubmit = document.querySelector(".filters__submit");
    const clearFiltersBtn = document.querySelector(".filters__btn-clear");
    let filtersOpen = document.querySelector(".filters--open");

    let rangeSlidersObjects = [];
    let selectedValues;

    if (filters) {
        selectedValues = filters.querySelector(".filters__selected");
        filters.addEventListener("click", function(e) {
            if (e.target.classList.contains("filters__input-title")) {
                e.target.parentElement.classList.toggle("open");
            }
        })
    }

    if (toggleInnerWrap && toggleInnerBtn) {
        toggleInnerBtn.addEventListener("click", function(){
            if (filtersOpen) {
                filtersOpen.classList.remove("filters--open");
                filtersOpen = false;
                toggleInnerWrap.classList.remove("open");
                this.classList.remove("open");
            }
            else {
                toggleInnerWrap.classList.toggle("open");
                this.classList.toggle("open");
            }
        });
    }

    function removeSelectedItem(item) {
        const parent = item.parentElement;
        if (parent.classList.contains("range")) {
            let inputMin = document.querySelector(`input[name='${parent.dataset.min}']`);
            let inputMax = document.querySelector("input[name='" + parent.dataset.max + "']");
            let titleMin = document.querySelector(".value[data-name='" + parent.dataset.min + "']");
            let titleMax = document.querySelector(".value[data-name='" + parent.dataset.max + "']");


            let slider = rangeSlidersObjects[inputMin.dataset.index];
            if (slider) {
                slider.setValue(parseInt(inputMax.dataset.base));
                slider.setValueStart(parseInt(inputMin.dataset.base));
                titleMin.innerText = Intl.NumberFormat().format(parseInt(inputMin.dataset.base)).replace(",", " ");
                titleMax.innerText = Intl.NumberFormat().format(parseInt(inputMax.dataset.base)).replace(",", " ");
                let track = slider.trackActive;
                let thumbs = slider.thumbs;
                let trackStyle = getComputedStyle(track).getPropertyValue("width");
                thumbs[0].style.transform = "translateX(0)";
                thumbs[1].style.transform = "translateX(" + trackStyle + ")";
                let sliderRoot = slider.root;
                sliderRoot.classList.remove("filled");
                sliderRoot.nextElementSibling.classList.remove("filled");
            }
        }
        else if (parent.classList.contains("number")) {
            let input = document.querySelector(`input[data-name="${parent.dataset.name}"][data-value]`);
            input.value = input.dataset.base;
        }
        else {
            let inputs = document.querySelectorAll("[data-name='" + parent.dataset.name + "'][data-value]");
            let input = inputs[0].parentElement.nextElementSibling;
            input.innerHTML = "";
            for (let i = 0; i < inputs.length; i++) {
                inputs[i].classList.remove("selected");
            }
        }
        parent.remove();
    }

    const setSliderList = (e, listMin, listMax, slider) => {
        let listMinItems = listMin.querySelectorAll("[data-value]");
        let listMaxItems = listMax.querySelectorAll("[data-value]");
        let valueMin = slider.getValueStart();
        let valueMax = slider.getValue();
        slider.root.classList.add("filled");
        slider.root.nextElementSibling.classList.add("filled");
        for (let i = 0; i < listMinItems.length; i++) {
            if (parseInt(listMinItems[i].dataset.value) > valueMax) {
                listMinItems[i].classList.add("inactive");
            }
            else {
                listMinItems[i].classList.remove("inactive");
            }
        }

        for (let i = 0; i < listMaxItems.length; i++) {
            if (parseInt(listMaxItems[i].dataset.value) < valueMin) {
                listMaxItems[i].classList.add("inactive");
            }
            else {
                listMaxItems[i].classList.remove("inactive");
            }
        }



        let inputMin = document.querySelector("input[data-text='" + e.target.dataset.text + "'][data-type='min']");
        let inputMax = document.querySelector("input[data-text='" + e.target.dataset.text + "'][data-type='max']");


        let checkSelected = document.querySelector(".filters__selected-item[data-name='" + inputMin.dataset.text + "']");
        if (parseInt(inputMin.value) !== parseInt(inputMin.dataset.base) || parseInt(inputMax.value) !== parseInt(inputMax.dataset.base)) {
            let space = " ";
            if (inputMin.name === "kat-nachylenia-dachu_from" || inputMax.name === "kat-nachylenia-dachu_to") {
                space = "";
            }
            if (checkSelected) {
                let value = checkSelected.querySelector(".value");
                value.innerHTML = "od " + Intl.NumberFormat().format(inputMin.value).replace(",", " ") + space + inputMin.dataset.unit + " do " + Intl.NumberFormat().format(inputMax.value).replace(",", " ") + space + inputMax.dataset.unit;
            }
            else {
                const selected = document.createElement("div");
                selected.dataset.min = inputMin.name;
                selected.dataset.max = inputMax.name;
                selected.classList.add("filters__selected-item");
                selected.classList.add("range");
                const remove = document.createElement("div");
                remove.classList.add("filters__selected-item-remove");
                const text = document.createElement("span");
                text.classList.add("text");
                const value = document.createElement("span");
                value.classList.add("value");
                value.dataset.value = e.target.dataset.value;
                text.innerText = inputMin.dataset.text + " ";
                value.innerHTML = "od " + Intl.NumberFormat().format(inputMin.value).replace(",", " ") + space + inputMin.dataset.unit + " do " + Intl.NumberFormat().format(inputMax.value).replace(",", " ") + space + inputMax.dataset.unit;
                selected.appendChild(text);
                selected.appendChild(value);
                selected.dataset.name = inputMin.dataset.text;
                selected.dataset.value = "input";
                selected.dataset.index = e.target.dataset.index;
                selected.appendChild(remove);
                if (selectedValues) {
                    selectedValues.appendChild(selected);
                }
            }

        }
        else if (parseInt(inputMin.value) === parseInt(inputMin.dataset.base) && parseInt(inputMax.value) === parseInt(inputMax.dataset.base)) {
            if (checkSelected) {
                checkSelected.remove();
            }
            slider.root.classList.remove("filled");
            slider.root.nextElementSibling.classList.remove("filled");
        }
    }

    for (let i = 0; i < mdcSliders.length; i++) {
        let slider = new MDCSlider(mdcSliders[i]);
        rangeSlidersObjects.push(slider);
        let titleMin = mdcSliders[i].parentElement.querySelector(".value[data-type='min']");
        let titleMax = mdcSliders[i].parentElement.querySelector(".value[data-type='max']");
        let parent = mdcSliders[i].parentElement;
        let listMin = parent.querySelector("[data-list='min']");
        let listMax = parent.querySelector("[data-list='max']");
        mdcSliders[i].addEventListener("MDCSlider:input", function(){
            let inputs = this.querySelectorAll("input[type='range']");
            let inputMin = this.querySelector("input[data-type='min']");
            let inputMax = this.querySelector("input[data-type='max']");
            let valueMin = inputMin.value;
            let valueMax = inputMax.value;
            let listMinItems = listMin.querySelectorAll("[data-value]");
            let listMaxItems = listMax.querySelectorAll("[data-value]");
            for (let i = 0; i < inputs.length; i++) {
                let title = this.parentElement.querySelector(".value[data-name='" + inputs[i].name + "']");
                title.innerText = Intl.NumberFormat().format(inputs[i].value).replace(",", " ");
            }
            for (let i = 0; i < listMinItems.length; i++) {
                if (parseInt(listMinItems[i].dataset.value) > valueMax) {
                    listMinItems[i].classList.add("inactive");
                }
                else {
                    listMinItems[i].classList.remove("inactive");
                }
            }


            for (let i = 0; i < listMaxItems.length; i++) {
                if (parseInt(listMaxItems[i].dataset.value) < valueMin) {
                    listMaxItems[i].classList.add("inactive");
                }
                else {
                    listMaxItems[i].classList.remove("inactive");
                }
            }
        });
        mdcSliders[i].addEventListener("MDCSlider:change", function(e){
            let inputs = this.querySelectorAll("input[type='range']");
            let inputMin = this.querySelector("input[data-type='min']");
            let inputMax = this.querySelector("input[data-type='max']");
            let valueMin = inputMin.value;
            let valueMax = inputMax.value;
            let listMinItems = listMin.querySelectorAll("[data-value]");
            let listMaxItems = listMax.querySelectorAll("[data-value]");
            for (let i = 0; i < inputs.length; i++) {
                let title = this.parentElement.querySelector(".value[data-name='" + inputs[i].name + "']");
                title.innerText = Intl.NumberFormat().format(inputs[i].value).replace(",", " ");
            }
            for (let i = 0; i < listMinItems.length; i++) {
                if (parseInt(listMinItems[i].dataset.value) > valueMax) {
                    listMinItems[i].classList.add("inactive");
                }
                else {
                    listMinItems[i].classList.remove("inactive");
                }
            }


            for (let i = 0; i < listMaxItems.length; i++) {
                if (parseInt(listMaxItems[i].dataset.value) < valueMin) {
                    listMaxItems[i].classList.add("inactive");
                }
                else {
                    listMaxItems[i].classList.remove("inactive");
                }
            }

            let checkSelected = document.querySelector(".filters__selected-item[data-name='" + inputMin.dataset.text + "']");
            if (parseInt(inputMin.value) !== parseInt(inputMin.dataset.base) || parseInt(inputMax.value) !== parseInt(inputMax.dataset.base)) {
                let space = " ";
                if (inputMin.name === "kat-nachylenia-dachu_from" || inputMax.name === "kat-nachylenia-dachu_to") {
                    space = "";
                }
                if (checkSelected) {
                    let value = checkSelected.querySelector(".value");
                    value.innerHTML = "od " + Intl.NumberFormat().format(inputMin.value).replace(",", " ") + space + inputMin.dataset.unit + " do " + Intl.NumberFormat().format(inputMax.value).replace(",", " ") + space + inputMax.dataset.unit;
                }
                else {
                    const selected = document.createElement("div");
                    selected.dataset.min = inputMin.name;
                    selected.dataset.max = inputMax.name;
                    selected.classList.add("filters__selected-item");
                    selected.classList.add("range");
                    const remove = document.createElement("div");
                    remove.classList.add("filters__selected-item-remove");
                    const text = document.createElement("span");
                    text.classList.add("text");
                    const value = document.createElement("span");
                    value.classList.add("value");
                    value.dataset.value = e.target.dataset.value;
                    text.innerText = inputMin.dataset.text + " ";
                    value.innerHTML = "od " + Intl.NumberFormat().format(inputMin.value).replace(",", " ") + space + inputMin.dataset.unit + " do " + Intl.NumberFormat().format(inputMax.value).replace(",", " ") + space + inputMax.dataset.unit;
                    selected.appendChild(text);
                    selected.appendChild(value);
                    selected.dataset.name = inputMin.dataset.text;
                    selected.dataset.value = "input";
                    selected.dataset.index = inputMin.dataset.index;
                    selected.appendChild(remove);
                    if (selectedValues) {
                        selectedValues.appendChild(selected);
                    }
                }
                this.classList.add("filled");
                this.nextElementSibling.classList.add("filled");
            }
            else if (parseInt(inputMin.value) === parseInt(inputMin.dataset.base) && parseInt(inputMax.value) === parseInt(inputMax.dataset.base)) {
                if (checkSelected) {
                    checkSelected.remove();
                }
                this.classList.remove("filled");
                this.nextElementSibling.classList.remove("filled");
            }
        });


        let sliderListMin = mdcSliders[i].parentElement.querySelector("[data-list='min']");
        sliderListMin.addEventListener("click", function(e){
            if (e.target.dataset.hasOwnProperty("value") && !e.target.classList.contains("inactive")) {
                slider.setValueStart(parseInt(e.target.dataset.value));
                titleMin.innerText = Intl.NumberFormat().format(e.target.dataset.value).replace(",", " ");
                this.classList.remove("open");
                setSliderList(e, listMin, listMax, slider);
            }
        });


        let sliderListMax = mdcSliders[i].parentElement.querySelector("[data-list='max']");
        sliderListMax.addEventListener("click", function(e){
            if (e.target.dataset.hasOwnProperty("value") && !e.target.classList.contains("inactive")) {
                slider.setValue(parseInt(e.target.dataset.value));
                titleMax.innerText = Intl.NumberFormat().format(e.target.dataset.value).replace(",", " ");
                this.classList.remove("open");
                setSliderList(e, listMin, listMax, slider);
            }
        });

    }

    if (filters) {
        const filterForm = document.querySelector(".filters__form");
        if (filterForm) {
            const checkboxes = filterForm.querySelectorAll(".filters__section-wrap--checkbox");
            if (!filterForm.classList.contains("looking-project-form__form")) {
                filterForm.addEventListener("submit", function (e) {
                    e.preventDefault();
                    document.querySelector("body").classList.add("loading");
                    const rangeInputs = this.querySelectorAll(".mdc-slider__input");
                    const numberInputs = this.querySelectorAll(".js-watch-number");
                    for (let i = 0; i < rangeInputs.length; i++) {
                        if ((rangeInputs[i].value === rangeInputs[i].dataset.base) && !rangeInputs[i].parentElement.classList.contains("filled")) {
                            rangeInputs[i].disabled = true;
                        }
                    }
                    for (let i = 0; i < numberInputs.length; i++) {
                        if (numberInputs[i].value === numberInputs[i].dataset.base) {
                            numberInputs[i].disabled = true;
                        }
                    }
                    if (this.classList.contains("hp-top__filters-form")) {
                        const formData = new FormData(this);
                        const formParams = new URLSearchParams(formData).toString();
                        this.action += `?${formParams}`;
                    }
                    this.submit();
                });
            }
            filterForm.addEventListener("change", function(e){
                let checkSelected = false;
                if (e.target.dataset.hasOwnProperty("name")) {
                    checkSelected = document.querySelector(".filters__selected-item[data-name='" + e.target.dataset.name + "']");
                }
                if (e.target.classList.contains("js-watch-number") && e.target.value !== "" && parseInt(e.target.value) !== 0) {
                    if (!checkSelected) {
                        const selected = document.createElement("div");
                        selected.classList.add("filters__selected-item");
                        selected.classList.add("number");
                        const remove = document.createElement("div");
                        remove.classList.add("filters__selected-item-remove");
                        const text = document.createElement("span");
                        text.classList.add("text");
                        const value = document.createElement("span");
                        value.classList.add("value");
                        value.dataset.value = e.target.dataset.value;
                        text.innerText = e.target.dataset.name + " ";
                        value.innerText = e.target.value + "m";
                        selected.appendChild(text);
                        selected.appendChild(value);
                        selected.dataset.name = e.target.dataset.name;
                        selected.dataset.value = "input";
                        selected.appendChild(remove);
                        if (selectedValues) {
                            selectedValues.appendChild(selected);
                        }
                    }
                    else {
                        checkSelected.innerText = e.target.dataset.name + " " + e.target.value + "m";
                        const remove = document.createElement("div");
                        remove.classList.add("filters__selected-item-remove");
                        checkSelected.appendChild(remove);
                    }
                }
                if ((e.target.value === "" || e.target.value === 0) && !e.target.classList.contains("custom-placeholder")) {
                    e.target.value = 0;
                    if (checkSelected) {
                        checkSelected.remove();
                    }
                }

            });
            if (selectedValues) {
                selectedValues.addEventListener("click", function(e){
                    if (e.target.classList.contains("filters__selected-item-remove")) {
                        removeSelectedItem(e.target);
                        if (window.location.search !== "" && window.location.search.indexOf("filters") === -1 && window.location.search.indexOf("?sort=") === -1) {
                            if (this.children.length === 0) {
                                window.location.search = "?filters=1";
                                return;
                            }
                            document.querySelector("body").classList.add("loading");
                            filterSubmit.click();
                        }
                    }

                });
            }
            // checkbox
            if (checkboxes.length > 0) {
                for (let i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].addEventListener("click", function(e){
                        if (e.target.dataset.hasOwnProperty("value")) {
                            let selectedItem = document.querySelector(".filters__selected-item[data-name='" + e.target.dataset.name + "']");
                            if (!selectedItem) {
                                selectedItem = document.createElement("div");
                                selectedItem.classList.add("filters__selected-item");
                                selectedItem.dataset.name = e.target.dataset.name;
                                const remove = document.createElement("div");
                                remove.classList.add("filters__selected-item-remove");
                                const text = document.createElement("span");
                                text.classList.add("text");
                                const values = document.createElement("div");
                                values.classList.add("values");
                                const valuesWrap = document.createElement("div");
                                valuesWrap.classList.add("values-wrap");
                                text.innerText = e.target.dataset.name + " ";
                                valuesWrap.appendChild(values)
                                selectedItem.appendChild(text);
                                selectedItem.appendChild(valuesWrap);
                                selectedItem.appendChild(remove);
                                if (selectedValues) {
                                    selectedValues.appendChild(selectedItem);
                                }
                            }
                            e.target.classList.toggle("selected");
                            if (e.target.classList.contains("radiobtn")) {
                                const radioInputs = e.target.parentElement.querySelectorAll("[data-name='" + e.target.dataset.name + "'][data-value]");
                                for (let i = 0; i < radioInputs.length; i++) {
                                    if (radioInputs[i].dataset.value !== e.target.dataset.value) {
                                        radioInputs[i].classList.remove("selected");
                                    }
                                }
                            }
                            const elements = this.querySelectorAll("[data-value]");
                            const submits = this.querySelector(".filters__submits");
                            submits.innerHTML = "";
                            // const input = this.querySelector("input[type='hidden']");
                            // let values = [];
                            let selectedItemValues = false;
                            if (selectedItem) {
                                selectedItemValues = selectedItem.querySelector(".values");
                                selectedItemValues.innerHTML = "";
                            }
                            for (let i = 0; i < elements.length; i++) {
                                if (elements[i].classList.contains("selected")) {
                                    let submitInput = document.createElement("input");
                                    submitInput.type = "hidden";
                                    if (e.target.classList.contains("radiobtn")) {
                                        submitInput.name = elements[i].dataset.submitName;
                                    }
                                    else {
                                        submitInput.name = elements[i].dataset.submitName + "[]";
                                    }
                                    submitInput.value = elements[i].dataset.submit;
                                    submits.appendChild(submitInput);
                                    let value = document.createElement("span");
                                    value.classList.add("value");
                                    value.dataset.value = elements[i].dataset.value;
                                    value.innerText = elements[i].dataset.value;
                                    if (selectedItemValues) {
                                        selectedItemValues.appendChild(value);
                                    }
                                }
                            }
                            // input.value = input.name + "[" + values.join(",") + "]";
                            if (selectedItemValues.children.length === 0) {
                                selectedItem.remove();
                            }
                        }
                    });
                }
            }
        }


        const scrollWraps = document.querySelectorAll(".filters__scroll-wrap");
        if (scrollWraps.length > 0) {
            for (let i = 0; i < scrollWraps.length; i++) {
                new Simplebar(scrollWraps[i], {
                    autohide: false,
                })
            }
        }


        const listsBtns = document.querySelectorAll(".filters__custom-btn");
        const listsBtnsClose = document.querySelectorAll(".filters__custom-list-close");
        // const lists = document.querySelectorAll(".filters__custom-list");
        if (listsBtns.length > 0) {
            for (let i = 0; i < listsBtns.length; i++) {
                listsBtns[i].addEventListener("click", function(){
                    let list = this.parentElement.nextElementSibling;
                    list.classList.add("open");
                });
            }
        }
        if (listsBtnsClose) {
            for (let i = 0; i < listsBtnsClose.length; i++) {
                listsBtnsClose[i].addEventListener("click", function(){
                    let list = this.parentElement;
                    list.classList.remove("open");
                });
            }
        }
    }

    if (toggleWrap && toggleBtn) {
        toggleBtn.addEventListener("click", function(){

            toggleWrap.classList.add("open");
            filters.parentElement.classList.add("open");
            if (filtersOpen) {
                filtersOpen.classList.remove("filters--open");
                filtersOpen = false;
            }
        });

    }
    if (toggleWrap && toggleCloseBtn) {
        toggleCloseBtn.addEventListener("click", function(){
            if (filtersOpen) {
                filtersOpen.classList.remove("filters--open");
                filtersOpen = false;
            }
            toggleWrap.classList.remove("open");
            filters.parentElement.classList.remove("open");
        });
    }
    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener("click", function(){
            document.querySelector("body").classList.add("loading");
        });
    }


    let hpFilters = false;
    if (filters && filters.classList.contains("hp")) {
        hpFilters = true;
    }
    if (!hpFilters && selectedValues) {
        if (selectedValues.children.length > 0) {
            selectedValues.classList.add("open");
            clearFiltersBtn.classList.add("active");
        }

        // Options for the observer (which mutations to observe)
        const config = { childList: true };

        // Callback function to execute when mutations are observed
        const callback = function(mutationsList, observer) {
            // Use traditional 'for loops' for IE 11
            for(const mutation of mutationsList) {
                if (mutation.type === 'childList') {
                    if (selectedValues.children.length > 0) {
                        selectedValues.classList.add("open");
                        clearFiltersBtn.classList.add("active");
                    }
                    else {
                        selectedValues.classList.remove("open");
                        clearFiltersBtn.classList.remove("active");
                    }
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(selectedValues, config);
    }

}

export default filters;
